import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { Channel } from '../model/interfaces/channel.interface';

const serviceUrl = "api/configuracionChannel";
const contactos = [
  {
    id: 6,
    Nombre: 'Troy',
    Apellido: 'Mcclure',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/troy-mcclure.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'noseolvidendetroy@gmail.com.ar'
  },
  {
    id: 5,
    Nombre: 'Esteban',
    Apellido: 'Wiedemann',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/nico.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'wiedemann.en@gmail.com'
  },
  {
    id: 1,
    Nombre: 'Federico',
    Apellido: 'Rocha',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/fede.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'federiconrocha@gmail.com.ar'
  },
  {
    id: 2,
    Nombre: 'Homer Jay',
    Apellido: 'Simpson',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/homero.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'soyhomero@gmail.com.ar'
  },
  {
    id: 3,
    Nombre: 'Leandro',
    Apellido: 'Se los Santos',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/lean.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'Leandro.delossantos@smart-ix.com'
  },
  {
    id: 4,
    Nombre: 'Marcelo',
    Apellido: 'Sosa',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/marcelo.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'marcelo.sosa@smart-ix.com'
  },
  {
    id: 5,
    Nombre: 'Esteban',
    Apellido: 'Wiedemann',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/nico.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'wiedemann.en@gmail.com'
  },
  {
    id: 6,
    Nombre: 'Troy',
    Apellido: 'Mcclure',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/troy-mcclure.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'noseolvidendetroy@gmail.com.ar'
  },
  {
    id: 0,
    Nombre: 'Elvio',
    Apellido: 'Velasquez',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/default.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'elvio.velasquez@contractor.inworx.com'
  }
];
export interface VariableCircuitoOut {
  codigo: string;
  titulo: string;
  valorDefault: string;
  tipo: string;
  extraInfo: string;
  esOpcional: boolean;
}
export interface ResponseConfiguration {
  form: VariableCircuitoOut[];
  msgresult;
}
export interface VariableCircuitoIn {
  codigo: string;
  valor: string;
}

interface RequestInvocacion {
  comando;
  formulario: VariableCircuitoIn[];
}
export interface ResponseInvocacionChannelSetting {
  errores: Array<string>;
  msgResult: string;
  info: VariableCircuitoIn[];
}
export interface APISXResultData<T> {
  result: T;
  errores: APISXError[];
}
export interface APISXError {
  errorCode: string;
  errorMessage: string;
}

@Injectable()
export class ChannelsService {
  constructor(private sxHttp: SxHttpService) { }

  getChannels(organizationCode: string,codSubscription: string, state: string = null ): Observable<Channel[]> {
    const search = {
      codSubscription,
    };

    if (state) {
      search['state'] = state;
    }
    
    return this.sxHttp
      .get(`${serviceUrl}/${organizationCode}/${codSubscription}`, search)
      .map(response => response.json().data as Channel[]);
  }

  getDetailChannel(
    codOrganization: string,
    codSubscription: string,
    codChannel: string
  ): Observable<Channel> {
    return this.sxHttp
      .get(`${serviceUrl}/Get/${codOrganization}/${codSubscription}/${codChannel}`)
      .map(response => response.json().data as Channel);
  }

  getUsers(
    codSubscription: string,
    codChannel: string
  ): Observable<string[]> {
    return this.sxHttp
      .get('api/configuracionChannel/' + codSubscription + '/' + codChannel+'/GetUsers')
      .map(response => response.json().data as string[]);
  }
  
  //I get the list of external attributes from the CommercialProduct
  getAttributes(codSubscription: string,
    codChannel: string): Promise<ResponseConfiguration> {
    let url = `api/configuracionChannel/GetAttributes/${codSubscription}/${codChannel}`;

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => {
        const data = response.json().data;
        const res = {
          form: data.formulario,
          msgresult: data.msgResult
        } as ResponseConfiguration;
        return res;
      });
  }

  //Update attributes 
  saveAttributes(codSubscription: string, codChannel: string, form: VariableCircuitoIn[]): Promise<ResponseInvocacionChannelSetting> {
    const requestInvocacion: RequestInvocacion = {
      comando: "",
      formulario: form
    };
    const url = `api/configuracionChannel/UpdateAttributes/${codSubscription}/${codChannel}`;
    return this.sxHttp.post(url, requestInvocacion)
      .toPromise()
      .then(response => response.json().data as ResponseInvocacionChannelSetting);
  }


  /**
   * get the business list from backend and map it
   * to a compatible format for the General Listing component
   */
  getForList(codorganization:string,codSubscription: string): Observable<ItemGeneralListado[]> {
    return this.sxHttp
      .get(`${serviceUrl}/${codorganization}/${codSubscription}`)
      .map(response => {
        return response.json().data.map(channel => {
          return {
            id: channel.channelCode,
            Titulo: channel.descripcion,
            Descripcion: channel.descripcionExt,
            Imagen: channel.urlImage,
            contactos // HACK: contactos hardcodeados
          };
        }) as ItemGeneralListado[];
      });
  }

  /**
   * Edit an existing channel to the backend
   */
  editar(
    organizationCode: string,
    subscriptionCode: string = 'CONF',
    channelCode: string,
    datos: any
  ): Promise<Channel> {
    delete datos['completitud'];
    return this.sxHttp
      .put(`${serviceUrl}` +
         '/' + organizationCode + 
         '/' + subscriptionCode +
         '/' + channelCode, datos)
      .toPromise()
      .then(response => response.json().data as Channel);
  }

  crearDesdeUnCodigo(channel: Channel) {
    return this.sxHttp
      .post(`${serviceUrl}`, channel)
      .toPromise()
      .then(response => response.json().data as Channel);
  }

  /**
   * Delete existing channel to the backend
   */
  deleteChannel(organizationCode: string, subscriptionCode: string, channelCode: string): Observable<any> {
    return this.sxHttp
      .delete(`${serviceUrl}/` + 
      organizationCode + '/' +
      subscriptionCode + '/' +
      channelCode + `/Delete`)
      .map(result => result.json().data);
  }

  /**
   * Active an existing channel to the backend
   */
  activar(organizationCode: string, subscriptionCode: string, channelCode: string): Promise<Channel> {
    const url = `${serviceUrl}/` +
    organizationCode + '/' +
    subscriptionCode + '/' +
    channelCode + '/' +
    `/activar`;
    return this.sxHttp
      .put(url, null)
      .toPromise()
      .then(response => response.json().data as Channel);
  }

  /**
   * Enable Api Access for external users
   * @param systemCode
   * @param businessCode
   * @param enableApiAccess
   */
  enableApiAccess(codSubscription: string, codChannel: string, channel: Channel): Promise<Boolean> {
    const url = `api/configuracionChannel/${codSubscription}/${codChannel}/enableApiAccess`;
    return this.sxHttp
      .put(url, channel)
      .toPromise()
      .then(result => result.json().data as Boolean);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/channels.service.ts